module.exports = __webpack_public_path__ + "static/media/img21.4b1f678f.jpg";